import { api, type QueryParams } from "@/lib/api/client";

export interface RosterStaff {
  user_id: string;
  name: string;
  employee_number: string | null;
  covering_from: string | null;
  note: string | null;
}

export interface RosterBranch {
  branch_id: string;
  branch_code: string;
  branch_name: string;
  min_headcount: number;
  headcount: number;
  understaffed: boolean;
  staff: RosterStaff[];
}

export interface RosterAway {
  user_id: string;
  name: string;
  employee_number: string | null;
  reason: string;
}

export interface RosterDay {
  date: string;
  branches: RosterBranch[];
  on_leave: RosterAway[];
  resting: RosterAway[];
}

export interface Assignment {
  id: string;
  user_id: string;
  branch_id: string;
  start_date: string;
  end_date: string;
  note: string | null;
  employee_name: string | null;
  branch_name: string | null;
}

export const scheduleKeys = {
  all: ["schedule"] as const,
  roster: (from: string, to: string) => [...scheduleKeys.all, "roster", from, to] as const,
  assignments: (filters: QueryParams) => [...scheduleKeys.all, "assignments", filters] as const,
  mine: () => [...scheduleKeys.all, "mine"] as const,
};

export const scheduleApi = {
  roster: (from: string, to: string) =>
    api.get<RosterDay[]>("/schedule", { query: { from, to } }),

  assignments: (filters: QueryParams) =>
    api.get<Assignment[]>("/schedule/assignments", { query: filters }),

  createAssignment: (payload: {
    user_id: string;
    branch_id: string;
    start_date: string;
    end_date: string;
    note?: string | null;
  }) => api.post<Assignment>("/schedule/assignments", payload),

  cancelAssignment: (id: string) =>
    api.post<{ message: string }>(`/schedule/assignments/${id}/cancel`),

  myAssignments: () => api.get<Assignment[]>("/me/assignments"),
};
